import {
  LanguageList,
  type LanguageType,
  type LanguageMapType
} from '@models/entities/languages'

export const LANGUAGE_MAP: LanguageMapType = {
  [LanguageList.RU]: {
    key: LanguageList.RU,
    title: 'Русский',
    shortName: 'RU'
  },
  [LanguageList.EN]: {
    key: LanguageList.EN,
    title: 'English',
    shortName: 'EN'
  },
  [LanguageList.DE]: {
    key: LanguageList.DE,
    title: 'Deutsch',
    shortName: 'DE'
  },
  [LanguageList.PTBR]: {
    key: LanguageList.PTBR,
    title: 'Português',
    shortName: 'PT'
  },
  [LanguageList.HI]: {
    key: LanguageList.HI,
    title: 'हिंदी',
    shortName: 'HI'
  },
  [LanguageList.UK]: {
    key: LanguageList.UK,
    title: 'Український',
    shortName: 'UA'
  },
  [LanguageList.AZ]: {
    key: LanguageList.AZ,
    title: 'Azərbaycan',
    shortName: 'AZ'
  },
  [LanguageList.ES]: {
    key: LanguageList.ES,
    title: 'Español',
    shortName: 'ES'
  },
  [LanguageList.UZ]: {
    key: LanguageList.UZ,
    title: 'O\'zbek',
    shortName: 'UZ'
  },
  [LanguageList.KK]: {
    key: LanguageList.KK,
    title: 'Қазақ',
    shortName: 'KZ'
  },
  [LanguageList.BN]: {
    key: LanguageList.BN,
    title: 'বাংলা',
    shortName: 'BN'
  }
}

export const APP_LANGUAGES = Object.keys(LANGUAGE_MAP) as LanguageType[]
